<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Шаблоны ответов
    v-col(cols="12")
      v-card(outlined)
        templates-table

</template>
<script>
import TemplatesTable from './components/TemplatesTable.vue';

export default {
  components:{
    TemplatesTable,
  },
  data: () => ({
    tab:null,
  }),
};
</script>

<style>

</style>
